"use strict";
$(window).on("load",function(){
    $("body").prepend('<style type="text/css">.snize-ac-results{opacity:0;}</style>');
});
$('form input[type="search"],form input#snize-mobile-search-input').on("change paste keyup",function(){
    if ( $("body>div").hasClass("snize-ac-results") ) {
        setInterval(function(){
            if ( $(window).width() < 1025 ) {
              	var searchinizeFlexMobile = $(".snize-ac-results>.snize-ac-results-content");
                searchinizeFlexMobile.css({"display":"flex"});
              	searchinizeFlexMobile.find(".snize-mobile-top-panel").attr("style","order:0;");
              	searchinizeFlexMobile.find("#snize-ac-items-container-1").attr("style","order:2;");
              	searchinizeFlexMobile.find("#snize-ac-items-container-2").attr("style","order:3;");
              	searchinizeFlexMobile.find("#snize-ac-items-container-3").attr("style","order:4;");
                searchinizeFlexMobile.find("#snize-ac-items-container-4").attr("style","order:1;");
            } 
          	if ( $(window).width() >= 1025 ) {
                var searchinizeFlex = $(".snize-ac-results>.snize-ac-results-content>.snize-ac-results-columns");
                searchinizeFlex.css({"display":""});
                searchinizeFlex.find(".snize-ac-results-column").eq(0).attr("style","");
                searchinizeFlex.find(".snize-ac-results-column").eq(1).attr("style","");
            }
        },200);
        setTimeout(function(){
             $(".snize-ac-results").animate({
                opacity: "1"
            },400);
        },800);
    }
});

var NaNterval = setInterval(function(){
    if ( $(window).width() < 1025 ) {
        var searchinizeFlexMobile = $(".snize-ac-results>.snize-ac-results-content");
        searchinizeFlexMobile.css({"display":"flex","flex-direction":"column"});
        searchinizeFlexMobile.find(".snize-mobile-top-panel").attr("style","order:0;");
        searchinizeFlexMobile.find("#snize-ac-items-container-1").attr("style","order:2;");
        searchinizeFlexMobile.find("#snize-ac-items-container-2").attr("style","order:3;");
        searchinizeFlexMobile.find("#snize-ac-items-container-3").attr("style","order:4;");
        searchinizeFlexMobile.find("#snize-ac-items-container-4").attr("style","order:1;");
    } 
    if ( $(window).width() >= 1025 ) {
        var searchinizeFlex = $(".snize-ac-results>.snize-ac-results-content>.snize-ac-results-columns");
        searchinizeFlex.css({"display":""});
        searchinizeFlex.find(".snize-ac-results-column").eq(0).attr("style","");
        searchinizeFlex.find(".snize-ac-results-column").eq(1).attr("style","");
    }
},200);

$("#shopify-section-header-template-2 .tt-mobile-header")
	.find(".tt-mobile-parent-menu-icons .tt-search.tt-dropdown-obj")
		.find("button.tt-dropdown-toggle").on("click touchstart touchend",function(){
			setTimeout(function(){
                 $(".snize-ac-results").animate({
                    opacity: "1"
                },400);
            },800);
});